import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  body {
    margin: 12px; 
  }
`;
